module.exports = __webpack_public_path__ + "img/25 Animation 2-squashed.6e337aec.jpg";